import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const Scrolltop = ({ scrollContainerRef }) => {
  const location = useLocation();

  useEffect(() => {
    if (scrollContainerRef && scrollContainerRef.current) {
      scrollContainerRef.current.scrollTop = 0;
    }
  }, [location, scrollContainerRef]);

  return null;
};

export default Scrolltop;
